<template>
  <v-container>
    <div class="breadcrumbs-wrap">
      <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>
    </div>
    <h1 class="title-pg">{{ $t('Отчеты по БСО') }}</h1>
    <div class="my-organization">
      <div class="create-quota-pg bso-reports bgw-pdg-20">
        <p class="status text-center"
           v-if="faunaLicenseApplicationBso.permitReport && faunaLicenseApplicationBso.permitReport.statusName">
          {{ $t('Статус') }}: {{ faunaLicenseApplicationBso.permitReport.statusName }}
        </p>
        <h4 class="text-center">{{ faunaLicenseApplicationBso.applicationPermitOoptName }}</h4>
        <div class="bso-reports__body">
          <div class="tab-main">
            <v-tabs
              v-model="tabReport"
              background-color="transparent"
              color="#333"
              slider-color="transparent"
            >
              <v-tab>{{ $t('Разрешение') }}</v-tab>
              <v-tab v-if="children.shooting_card">{{ $t('Отстрелочные карты') }}</v-tab>
              <v-tab v-if="children.trophySheet">{{ $t('Трофейные листы') }}</v-tab>
              <v-tab-item class="pb-2">
                <div>
                  <h5 class="text-center mt-0">{{ $t('Разрешение') }} №
                    {{ faunaLicenseApplicationBso.strictReportingFormTypeSeria }}
                    {{ faunaLicenseApplicationBso.bsoNumber }}</h5>
                  <div class="form-group">
                    <div class="quota-fields">
                      <div class="quota-field"
                           v-if="faunaLicenseApplicationBso.validDateFrom || faunaLicenseApplicationBso.validDateTo">
                        {{ $t('Срок действия') }}: {{ faunaLicenseApplicationBso.validDateFrom }}<span
                          v-if="faunaLicenseApplicationBso.validDateTo">-{{ faunaLicenseApplicationBso.validDateTo }}</span>
                      </div>
                      <div class="quota-field" v-if="faunaLicenseApplicationBso.applicationPermitIssueDate">
                        {{ $t('Дата выдачи') }}: {{ faunaLicenseApplicationBso.applicationPermitIssueDate }}
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <div class="quota-fields">
                      <div class="quota-field field-block">
                        <p>{{ $t('Место пользования') }}: {{ permitReport.observePlotName }}</p>
                        <p>{{ $t('Уточнение по месту пользования') }}: {{ permitReport.observePlotNote }}</p>
                      </div>
                      <div class="quota-field field-block">
                        <p>{{ $t('Ответственное лицо охотпользователя') }}: {{ permitReport.ooptObserverFio }}</p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group">
                    <PermitReportTable :faunaLicenseApplicationBsoItems="faunaLicenseApplicationBsoItems"/>
                  </div>
                  <div class="form-group">
                    <div class="quota-fields">
                      <div class="quota-field field-block">
                        <p>{{ $t('Разрешение продлено') }}: {{ permitReport.permitDateFrom }}<span
                          v-if="permitReport.permitDateTo">-{{ permitReport.permitDateTo }}</span></p>
                      </div>
                    </div>
                  </div>
                  <div class="form-group" v-if="lastHistory">
                    <div class="quota-fields">
                      <div class="quota-field field-block">
                        <p>{{ $t('Дата присвоения статуса') }}: {{ lastHistory.date }}</p>
                        <p>{{ $t('Комментарий') }}: {{ lastHistory.comment }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </v-tab-item>
              <v-tab-item class="pb-5" v-if="children.shooting_card">
                <v-tabs
                  v-model="tabShootingCard"
                  background-color="transparent"
                  color="#333"
                  slider-color="transparent"
                >
                  <v-tab v-for="(shootingCard, index) in children.shooting_card" :key="index">
                    {{ shootingCard.strictReportingFormTypeCorrectName }} {{ shootingCard.bsoNumber }}
                  </v-tab>
                  <v-tab-item v-for="(shootingCard, index) in children.shooting_card" :key="index">
                    <div>
                      <div class="form-group">
                        <div class="quota-fields justify-content-between">
                          <div class="quota-field" v-if="shootingCard.validDateFrom || shootingCard.validDateTo">
                            {{ $t('Срок действия') }}: {{ shootingCard.validDateFrom }}<span
                            v-if="shootingCard.validDateTo">-{{ shootingCard.validDateTo }}</span>
                          </div>
                          <div class="quota-field">
                            {{ $t('Дата выдачи') }}: {{ faunaLicenseApplicationBso.applicationPermitIssueDate }}
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <div class="quota-fields">
                          <div class="quota-field field-block">
                            <p>{{ $t('Место пользования') }}: {{ shootingCardReport[index].observePlotName }}</p>
                            <p>{{ $t('Уточнение по месту пользования') }}: {{
                                shootingCardReport[index].observePlotNote
                              }}</p>
                          </div>
                          <div class="quota-field field-block">
                            <p>{{ $t('Охотник') }}: {{ shootingCardReport[index].ooptHunterFio }}</p>
                            <p>
                              {{ $t('Согласно по договору') }} №: {{ shootingCardReport[index].contract }}<span
                              v-if="shootingCardReport[index].dateFrom"> {{
                                $t('от')
                              }} {{ shootingCardReport[index].dateFrom }}</span>
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <table>
                          <thead>
                          <tr>
                            <td class="td-num">№</td>
                            <td class="text-center">{{ $t('Вид животного') }}</td>
                            <td class="text-center">{{ $t('Кол-во разрешенное') }}</td>
                            <td class="text-center">{{ $t('Кол-во добытых ж-х') }}</td>
                            <td class="text-center">{{ $t('Кол-во подранков') }}</td>
                            <td class="text-center">{{ $t('Дата добычи') }}</td>
                          </tr>
                          </thead>
                          <tbody>
                          <tr>
                            <td class="td-num">1</td>
                            <td>{{ shootingCard.faunaName }}</td>
                            <td>{{ shootingCardReport[index].allowedCount }}</td>
                            <td>{{ shootingCardReport[index].animalCount }}</td>
                            <td>{{ shootingCardReport[index].woundedCount }}</td>
                            <td>{{ shootingCardReport[index].takeDate }}</td>
                          </tr>
                          </tbody>
                        </table>
                      </div>
                      <div class="form-group">
                        <div class="quota-fields">
                          <div class="quota-field field-block">
                            {{ $t('Результат охоты') }}: {{ shootingCardReport[index].huntingResultName }}
                          </div>
                          <div class="quota-field field-block">
                            <p>{{ $t('Зарегистрировано в специально уполномоченном органе') }}:</p>
                            <p>{{ $t('Дата "до охоты"') }}: {{ shootingCardReport[index].huntingDateBefore }}</p>
                            <p>{{ $t('Дата "после охоты"') }}: {{ shootingCardReport[index].huntingDateAfter }}</p>
                          </div>
                        </div>
                      </div>
                      <div class="form-group">
                        <ReportDocuments v-bind:documents.sync="shootingCard.documents" :editable="false"
                                         :bsoId="index"/>
                      </div>
                    </div>
                  </v-tab-item>
                </v-tabs>
              </v-tab-item>
              <v-tab-item v-if="children.trophySheet" class="pb-2">
                <v-tabs
                  v-model="tabTrophySheet"
                  background-color="transparent"
                  color="#333"
                  slider-color="transparent"
                >
                  <v-tab v-for="(trophySheet, index) in children.trophySheet" :key="index">
                    {{ trophySheet.strictReportingFormTypeCorrectName }} {{ trophySheet.bsoNumber }}
                  </v-tab>
                  <v-tab-item v-for="(trophySheet, index) in children.trophySheet" :key="index">
                    <div class="form-group">
                      <p>{{ $t('Охотник') }}: {{ trophySheetReport[index].ooptHunterFio }}</p>
                    </div>
                    <div class="form-group">
                      <div class="quota-fields">
                        <div class="quota-field field-block">
                          <p>{{ $t('Место добычи') }}: {{ trophySheetReport[index].observePlotName }}</p>
                          <p>{{ $t('Уточнение по месту добычи') }}: {{ trophySheetReport[index].observePlotNote }}</p>
                        </div>
                        <div class="quota-field field-block">
                          <p>{{ $t('Дата и время добычи') }}: {{ trophySheetReport[index].dateTimeMining }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="quota-fields">
                        <div class="quota-field field-block">
                          <p>{{ $t('Широта') }}: {{ trophySheetReport[index].latitude }}</p>
                          <p>{{ $t('Долгота') }}: {{ trophySheetReport[index].longitude }}</p>
                        </div>
                        <div class="quota-field field-block" v-if="trophySheetReport[index].longitude && trophySheetReport[index].latitude">
                          <v-icon color="#0096BB"
                                  @click="runMap([parseFloat(trophySheetReport[index].longitude), parseFloat(trophySheetReport[index].latitude)])">
                            mdi-map-marker
                          </v-icon>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="quota-fields">
                        <div class="quota-field field-block">
                          <p>{{ $t('Биотип (тип угодий)') }}: {{ trophySheetReport[index].biotype }}</p>
                          <p>{{ $t('Возраст') }}: {{ trophySheetReport[index].age }}</p>
                          <p v-show="trophySheet.strictReportingFormTypeId !== trophySheetKaban && trophySheet.strictReportingFormTypeId !== trophySheetVolkOrdinary">{{ $t('Наибольший размах рогов') }}: {{ trophySheetReport[index].mostHornsLength }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group" v-show="trophySheet.strictReportingFormTypeId !== trophySheetKaban && trophySheet.strictReportingFormTypeId !== trophySheetVolkOrdinary">
                      <div class="quota-fields">
                        <div class="quota-field field-block">
                          <p>{{ $t('Длина рога правого') }}: {{ trophySheetReport[index].rightHornLength }}</p>
                          <p>{{ $t('Окружность рога у основания правого') }}:
                            {{ trophySheetReport[index].rightHornCircleFromBase }}</p>
                          <p>{{ $t('Окружность рога в начале второй трети длины правого') }}:
                            {{ trophySheetReport[index].rightHornCircle23 }}</p>
                        </div>
                        <div class="quota-field field-block">
                          <p>{{ $t('левого') }}: {{ trophySheetReport[index].leftHornLength }}</p>
                          <p>{{ $t('левого') }}: {{ trophySheetReport[index].leftHornCircleFromBase }}</p>
                          <p>{{ $t('левого') }}: {{ trophySheetReport[index].leftHornCircle23 }}</p>
                        </div>
                      </div>
                    </div>
                    <div class="form-group">
                      <div class="quota-field field-block">
                        <p>{{ $t('Трофейный лист заполнил(а) ФИО, должность') }}:
                          {{ trophySheetReport[index].huntsmanFio }}</p>
                        <p>{{ $t('При проведении тура охоты присутствовал и указанные сведения удостоверяет') }}:
                          {{ trophySheetReport[index].ooptObserverFio }}</p>
                      </div>
                    </div>
                  </v-tab-item>
                  <v-dialog
                    v-model="mapDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title class="headline grey lighten-2">
                        {{ $t('Точка на карте') }}
                      </v-card-title>
                      <v-card-text>
                        <MapPointView ref="mapRef" @cancel="mapDialog = false"/>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-tabs>
              </v-tab-item>
            </v-tabs>
          </div>
        </div>
        <!--Кнопки действии-->
        <div class="form-action text-center">
          <template v-for="actionPermission in actionPermissions">
            <button
              :key="actionPermission.id"
              @click="action(actionPermission)"
              :class="actionPermission.class"
              class="btn btn-default"
            >
              {{ actionPermission.name }}
            </button>
            <template
              v-if="actionPermission.type == 'permit_report_status' && actionPermission.comment === true">
              <v-dialog
                v-model="commentDialog[actionPermission.id]"
                scrollable
                max-width="600px"
                :key="'action_'+actionPermission.id"
              >
                <v-card class="modal observer-modal">
                  <div class="modal-head">
                    {{ $t('Добавление комментария') }}
                    <v-btn color="modal-close" @click="changeCommentDialog(actionPermission.id, false)">
                      <img src="@/assets/img/close-icon.png" alt="icon">
                    </v-btn>
                  </div>
                  <div class="modal-body">
                    <v-row>
                      <v-col cols="4" md="4" class="input-label">
                        <v-label>
                          {{ $t('Комментарий') }}:
                        </v-label>
                      </v-col>
                      <v-col class="input-field">
                        <v-textarea
                          v-model="comment"
                          outlined
                          dense
                          clearable
                        />
                      </v-col>
                    </v-row>
                    <div class="form-action">
                      <button
                        class="btn btn-default blue"
                        type="button"
                        @click="changeStatus({ id: actionPermission.id, type: actionPermission.type, comment: comment }),  changeCommentDialog(actionPermission.id, false)"
                      >
                        {{ $t('Добавить') }}
                      </button>
                      <button
                        class="btn btn-default gray"
                        type="button"
                        @click="changeCommentDialog(actionPermission.id, false)"
                      >
                        {{ $t('Отмена') }}
                      </button>
                    </div>
                  </div>
                </v-card>
              </v-dialog>
            </template>
          </template>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import PermitReport from '@/model/permitReport'
import ReportDocuments from '@/components/bso/ReportDocuments'
import PermitReportTable from '@/components/bso/PermitReportTable'
import MapPointView from '@/components/app/MapPointView'

export default {
  components: {
    ReportDocuments,
    PermitReportTable,
    MapPointView
  },
  data: () => ({
    breadcrumbs: [],
    tabReport: null,
    faunaLicenseApplicationBso: {},
    permitReport: {},
    children: [],
    tabShootingCard: null,
    tabTrophySheet: null,
    shootingCardReport: {},
    trophySheetReport: {},
    minedHuntingResult: null,
    notMinedHuntingResult: null,
    notTakePlaceHuntingResult: null,
    documents: [],
    isSpecialist: false,
    commentDialog: [],
    comment: null,
    actionPermissions: {},
    mapDialog: false,
    trophySheetKaban: null,
    trophySheetVolkOrdinary: null,
    lastHistory: {},
    faunaLicenseApplicationBsoItems: []
  }),
  mounted () {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    // загрузка данных
    fetchData () {
      this.setLoading(true)
      PermitReport.getFaunaLicenseApplicationBsoData(this.$route.params.id).then((response) => {
        this.faunaLicenseApplicationBso = response.data.item
        this.faunaLicenseApplicationBsoItems = this.faunaLicenseApplicationBso.faunaLicenseApplicationBsoItems
        this.permitReport = this.faunaLicenseApplicationBso.permitReport ? this.faunaLicenseApplicationBso.permitReport : {}
        this.children = this.faunaLicenseApplicationBso.children
        if (this.children.shooting_card) {
          Object.entries(this.children.shooting_card).forEach(([key, value]) => {
            this.shootingCardReport[key] = value.shootingCardReport ? value.shootingCardReport : {}
          })
        }
        if (this.children.trophySheet) {
          Object.entries(this.children.trophySheet).forEach(([key, value]) => {
            this.trophySheetReport[key] = value.trophySheetReport ? value.trophySheetReport : {}
          })
        }
        this.minedHuntingResult = response.data.minedHuntingResult
        this.notMinedHuntingResult = response.data.notMinedHuntingResult
        this.notTakePlaceHuntingResult = response.data.notTakePlaceHuntingResult
        this.documents = response.data.documents
        this.isSpecialist = response.data.isSpecialist
        this.lastHistory = response.data.lastHistory
        this.trophySheetKaban = response.data.trophySheetKaban
        this.trophySheetVolkOrdinary = response.data.trophySheetVolkOrdinary
        // БП
        if (this.permitReport.statusId) {
          this.getActions(this.permitReport.statusId)
        }
        this.generateBreadcrumbs()
        this.changeTab()
      })
        .catch((error) => {
          console.log(error)
          if (error) {
            this.$router.push({
              name: 'error',
              params: {
                status: error.response.status
              }
            })
          }
        })
      this.setLoading(false)
    },
    // список действий
    getActions (statusId) {
      PermitReport.getActions(statusId).then((response) => {
        this.actionPermissions = response.data
      })
    },
    // действия
    action (actionPermission) {
      if (actionPermission.type === 'permit_report_status') {
        if (actionPermission.comment === true) {
          this.changeCommentDialog(actionPermission.id, true)
        } else {
          this.changeStatus({
            id: actionPermission.id,
            type: actionPermission.type
          })
        }
      } else if (actionPermission.type === 'permit_report_edit') {
        this.$router.push({
          name: 'permit-report-edit',
          params: {
            id: this.$route.params.id
          }
        })
      } else if (actionPermission.type === 'permit_report_cancel') {
        this.onCancel()
      }
    },
    changeStatus (data) {
      PermitReport.changeStatus(this.faunaLicenseApplicationBso.permitReport.id, data)
        .then((response) => {
          this.faunaLicenseApplicationBso.permitReport.statusId = response.data.statusId
          this.faunaLicenseApplicationBso.permitReport.statusName = response.data.statusName
          this.permitReport.statusId = response.data.statusId
          this.permitReport.statusName = response.data.statusName
          this.lastHistory = response.data.lastHistory
          this.getActions(this.faunaLicenseApplicationBso.permitReport.statusId)
        })
        .catch((error) => {
          console.log(error)
          this.$noty.warning(this.$i18n.t('Ошибка'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
    },
    // изменение статуса модального окна для комментариев
    changeCommentDialog (id, flag) {
      this.comment = null
      this.$set(this.commentDialog, id, flag)
    },
    // хлебная крошка
    generateBreadcrumbs () {
      this.breadcrumbs = [
        {
          text: this.$i18n.t('Главная'),
          disabled: false,
          href: '/'
        },
        {
          text: this.$i18n.t('Рабочий кабинет'),
          disabled: false,
          href: '/my-organization'
        },
        {
          text: this.$i18n.t('Отчеты по БСО'),
          disabled: false,
          href: this.isSpecialist === true ? '/society-permit-reports/' + this.faunaLicenseApplicationBso.applicationPermitOoptId : '/permit-reports'
        },
        {
          text: this.$i18n.t('Разрешение') + ' № ' + this.faunaLicenseApplicationBso.strictReportingFormTypeSeria + ' ' + this.faunaLicenseApplicationBso.bsoNumber,
          disabled: true
        }
      ]
    },
    changeTab () {
      if (this.$route.query.tab) {
        this.tabReport = parseInt(this.$route.query.tab)
      }
      if (this.$route.query.tabShootingCard) {
        this.tabShootingCard = parseInt(this.$route.query.tabShootingCard)
      }
      if (this.$route.query.tabTrophySheet) {
        this.tabTrophySheet = parseInt(this.$route.query.tabTrophySheet)
      }
    },
    // Прокручивание к началу страницы
    scrollToTop () {
      window.scrollTo(0, 0)
    },
    // Отмена
    onCancel () {
      this.isSpecialist === true
        ? this.$router.push({
          name: 'society-permit-reports',
          params: {
            id: this.faunaLicenseApplicationBso.applicationPermitOoptId
          }
        })
        : this.$router.push({
          name: 'permit-reports'
        })
    },
    // вызов карты для координат
    runMap (coordinates) {
      this.mapDialog = true
      setTimeout(() => {
        this.$refs.mapRef.initCoordinates(coordinates)
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
